import React, { type SyntheticEvent } from "react";
import { useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { countBasketItems } from "../../../../utils/typedUtils";
import * as Styles from "./styles/BasketButton";
import Icon, { IconCart } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import Price from "../price/Price";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { SrOnly } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";

export type PropsType = {
    toggle: (event: SyntheticEvent) => void;
};

const enabledSteps = [NavStep.Customize, NavStep.Services, NavStep.Summary];

const BasketButton = ({ toggle }: PropsType): JSX.Element | null => {
    const step = useBnbSelector((state) => state.navigation.step);
    const basketTotalPrice = useBnbSelector((state) => state.basket.total);
    const selectedItems = useBnbSelector(countBasketItems);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const guideLabel = useBnbOptionalLabel("mobileFooterDisclaimerMonthly");
    const financeOptionTitleCashLabel = useBnbOptionalLabel("financeOptionTitleCash");
    const financeOptionTitleMonthlyLabel = useBnbOptionalLabel("financeOptionTitleMonthly");

    // hide basket on model, engine and buy
    if (!enabledSteps.includes(step)) return null;

    return (
        <Styles.Wrapper>
            <Styles.BasketTrigger type="button" onClick={toggle}>
                <SrOnly>
                    <BnbLabel label="bnbA11yButtonBasketOpen" />
                </SrOnly>
                <Icon variant="chevronUp" />
            </Styles.BasketTrigger>
            <Styles.Button onClick={toggle}>
                <SrOnly>
                    <BnbLabel label="bnbA11yButtonBasketOpen" />
                </SrOnly>
                <IconCart />
                {!!selectedItems && <Styles.BasketCounter>{selectedItems}</Styles.BasketCounter>}
            </Styles.Button>
            <Styles.Pricing>
                {financeOption === "cash" ? (
                    <Styles.FinanceTitle>{financeOptionTitleCashLabel}</Styles.FinanceTitle>
                ) : (
                    <Styles.FinanceTitle>
                        {financeInfo.productName ? financeInfo.productName : financeOptionTitleMonthlyLabel}
                    </Styles.FinanceTitle>
                )}
                {guideLabel && financeOption === "monthly" ? (
                    guideLabel
                ) : (
                    <Price price={basketTotalPrice} financeItemId="total" showLoader />
                )}
            </Styles.Pricing>
        </Styles.Wrapper>
    );
};

export default BasketButton;
